var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hero" }, [
    _c("div", { staticClass: "hero-body" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "title is-1" }, [
          _vm._v(
            "\n        Ny-Ålesund（ニーオルスン）観測ステーション散策\n      "
          ),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle is-2" }, [
          _vm._v(
            "\n        Ny-Ålesund観測ステーションは北緯78°55' 東経11°56'に位置します。\n        ノルウェー領スヴァールバル諸島のスピッツベルゲン島にあり、\n        人が定住する地としては世界最北に位置する町です。\n        我々はこの観測ステーションに観測拠点（基地）を建造し、定常的な観測を実施しています。\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "main-contents" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button-container" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button is-link is-large is-3",
                  attrs: { to: "/view" },
                },
                [
                  _vm._v(
                    "\n            Ny-Ålesund観測ステーションを散策しよう\n          "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "map" }, [
      _c("img", {
        staticClass: "svalbird",
        attrs: { src: "asset/svalbird_gmap.png", alt: "スヴァールバル諸島" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "na",
        attrs: { src: "asset/na_gmap.png", alt: "Ny-Ålesundi" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "button-container" }, [
      _c(
        "a",
        {
          staticClass: "button help",
          attrs: { href: "pdf/VRArctic_manual.pdf", target: "_blank" },
        },
        [_vm._v("\n            使い方\n          ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }